export enum SASVariant {
    DEFAULT,
    ROUNDED,
    INLINE
}

export class MenuItemModel {
    label: string;
    value: string;
    children?: MenuItemModel[];
    display: boolean;
    expanded?: boolean;
}

export class BasicSearchAndSelectModel {
    addCallback?: (parent: MenuItemModel) => void;
    addName?: string;
    className?: string;
    disabled?: boolean;
    expanded?: string[];
    fullWidth?: boolean;
    handleSearch?: (value: string, items: MenuItemModel[]) => MenuItemModel[];
    id?: string;
    items: MenuItemModel[];
    name?: string;
    onClick?: (e: MenuItemModel) => void | Promise<void>;
    selected?: string;
    title?: string;
    value?: any;
    variant?: SASVariant;
    test?: (parent: MenuItemModel) => void;
    setToValue?: (value: any) => void;
    disabledValues?: string[];
    disabledMessage?: string;
}
